import React from "react";
import { useTranslation } from "react-i18next";

import { Check } from "@airhelp/icons";
import { Flex } from "@chakra-ui/react";

import { AirLuggageStatus } from "models/journeys/AirLuggageJourney";

const getAirLuggageStatusBadge = (status?: AirLuggageStatus) => {
  const { t } = useTranslation();
  switch (status) {
    case AirLuggageStatus.ACTIVE:
      return {
        label: t("common.added"),
        style: {
          color: "success.500",
          backgroundColor: "success.200",
        },
      };
    case AirLuggageStatus.PAYOUT_SUCCESSFUL:
      return {
        label: (
          <Flex alignItems="center">
            <Check color="greyscale.100" boxSize={4} mr={0.5} />
            {t("common.paid")}!
          </Flex>
        ),
        style: {
          color: "greyscale.100",
          backgroundColor: "success.500",
        },
      };
    case AirLuggageStatus.ELIGIBLE:
      return {
        label: t("air_luggage.card.badge.eligible"),
        style: {
          color: "greyscale.100",
          backgroundColor: "success.500",
        },
      };
    case AirLuggageStatus.PAYOUT_FAILED:
    case AirLuggageStatus.PAYOUT_RETURNED:
      return {
        label: t("air_luggage.card.badge.resubmit_bank_details"),
        style: {
          color: "warning.500",
          backgroundColor: "warning.200",
        },
      };
    case AirLuggageStatus.INELIGIBLE:
    case AirLuggageStatus.UNREGISTERED:
      return {
        label: t("air_luggage.card.badge.claim_rejected"),
        style: {
          color: "warning.500",
          backgroundColor: "warning.200",
        },
      };
    case AirLuggageStatus.PROCESSING_PAYMENT:
    case AirLuggageStatus.MANUAL_VERIFICATION_PENDING:
      return {
        label: t("air_luggage.card.badge.checking_eligibility"),
        style: {
          color: "primary.400",
          backgroundColor: "primary.100",
        },
      };
    default:
      return {
        style: {
          color: "primary.400",
          backgroundColor: "primary.100",
        },
      };
  }
};

export default getAirLuggageStatusBadge;
